// extracted by mini-css-extract-plugin
export default {"wrapTitle":"SideBarBody_wrapTitle__PovZW","title":"SideBarBody_title__kavyr","children":"SideBarBody_children__P2yq7","labelInfoWrap":"SideBarBody_labelInfoWrap__PmGvG"};